import { CircularProgress, Stack } from "@mui/material";
import React from "react";

import Logo from "../../assets/images/logo_blue.svg";

export const LoadingLayout: React.FC = () => {
    return (
        <Stack alignItems="center" height="100%" justifyContent="center" spacing={4}>
            <Logo height={50} />
            <CircularProgress size={50} />
        </Stack>
    );
};
